/**
 *
 * @author: Matthew Rawson @ 29/09/2017 14:41
 * @description:
 * @notes:
 */
import styled from "styled-components"
import {minWidthMedia} from "@irati/ui/src/global/media"


export default styled.div`
  position: static;
  top: 0;
  left: 0;

  ${minWidthMedia.tablet`
    position: absolute;
    width: 100%;
  `}
`
